import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const LOGO = "/logo_fluo.png";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(err.response?.data?.detail || "Erreur de connexion");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <form
        onSubmit={submit}
        className="fluo-card w-full max-w-md p-8"
        data-testid="admin-login-form"
      >
        <img src={LOGO} alt="FLUO Neuchâtel" className="h-14 mx-auto mb-4" />
        <h1 className="font-display text-3xl text-center mb-1">Espace admin</h1>
        <p className="text-center text-white/40 text-sm mb-8">
          Réservé à l'équipe FLUO Neuchâtel
        </p>

        <label className="block uppercase text-xs tracking-widest text-white/40 mb-1">
          Email
        </label>
        <input
          type="email"
          required
          className="fluo-input mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
        />

        <label className="block uppercase text-xs tracking-widest text-white/40 mb-1">
          Mot de passe
        </label>
        <input
          type="password"
          required
          className="fluo-input mb-6"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
        />

        {error && (
          <div className="text-magenta text-sm mb-4" data-testid="admin-login-error">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="btn-fluo w-full"
          data-testid="admin-login-btn"
        >
          <LogIn size={16} /> {loading ? "Connexion…" : "Se connecter"}
        </button>

        <div className="flex items-center justify-center gap-2 text-xs text-white/40 mt-4">
          <Lock size={12} /> Connexion sécurisée
        </div>
      </form>
    </div>
  );
}
